import PropTypes from 'prop-types'
import React from 'react'
import MathJax from 'react-mathjax3'

const MathJaxComponent = ({ text }) => (
    <MathJax.Context
        input="tex"
        onLoad={() => console.log('Loaded MathJax script!')}
        onError={(MathJax, error) => {
            console.warn(error)
            console.log('Encountered a MathJax error, re-attempting a typeset!')
            MathJax.Hub.Queue(MathJax.Hub.Typeset())
        }}
        options={{
            messageStyle: 'none',
            extensions: ['tex2jax.js'],
            jax: ['input/TeX', 'output/HTML-CSS'],
            tex2jax: {
                inlineMath: [
                    ['$', '$'],
                    ['\\(', '\\)'],
                ],
                displayMath: [
                    ['$$', '$$'],
                    ['\\[', '\\]'],
                ],
                processEscapes: true,
            },
            TeX: {
                extensions: [
                    'AMSmath.js',
                    'AMSsymbols.js',
                    'noErrors.js',
                    'noUndefined.js',
                ],
            },
        }}
    >
        <MathJax.Html html={text} />
    </MathJax.Context>
)

MathJaxComponent.propTypes = {
    text: PropTypes.string,
}

export default MathJaxComponent
